export default __webpack_public_path__ + "static/media/ico-s3-score-moderate.99569d9f.svg";